export enum ReportType {
    MAIN_CAR_REPORT = 'MAIN_CAR_REPORT',
    TERMINAL_INSTALLATION_REPORT = 'TERMINAL_INSTALLATION_REPORT',
    ACTIVE_TERMINALS_REPORT = 'ACTIVE_TERMINALS_REPORT',
    VEHICLES_STATE_REPORT = 'VEHICLES_STATE_REPORT',
    CAR_RIDES_REPORT = 'CAR_RIDES_REPORT',
    CAR_PARKINGS_REPORT = 'CAR_PARKINGS_REPORT'
}
export enum ReportExtension {
    PDF = 'PDF',
    XLSX = 'XLSX',
    CSV = 'CSV'
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/ReportEnumTypes.ts